import type { RatingState } from "@esgt/event-store"
import { formatDate } from "./formatDate"

/**
 * Returns the date the report was last generated.
 *
 * Uses the most recent entry in the rating's report history, falling back to
 * the rating's completion date and finally today's date — the latter covers
 * previews where no report has been generated yet (e.g. the PDF preview).
 */
export const getReportPublishedDate = (ratingState?: RatingState): Date => {
  const raw = ratingState?.reportHistory?.at(-1)?.createdAt ?? ratingState?.completedAt
  return raw ? new Date(raw) : new Date()
}

/**
 * Formats the report's published date as a Norwegian month and year,
 * e.g. "april 2026".
 */
export const formatReportPublishedDate = (ratingState?: RatingState): string => {
  return formatDate(getReportPublishedDate(ratingState), "MMMM yyyy")
}
